import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
  caption?: string;
};
export function Countdown({
  tone = "light",
  caption = "The promotional price is available for a limited time."
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === "dark";
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="mx-auto mt-8 w-full max-w-md text-center" role="timer" aria-live="off" data-id="element-20" data-mp="3h2aa76nuh6tg">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-goldlight" : "text-navy"}`} data-id="element-21" data-mp="325j7aneypcz3">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="10dmxpjccud6y" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-23" data-mp="15a4vfz99pb9s">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="xzln9bkgk6om" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="t2d5vd74w6of">
              <span className={`flex h-[72px] w-[76px] items-center justify-center rounded-xl font-serif text-4xl font-bold tabular-nums sm:h-20 sm:w-24 sm:text-5xl ${dark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-26" data-mp="t1tn5u9nte9c">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-widest ${dark ? "text-white/60" : "text-ink/50"}`} data-id="element-27" data-mp="a37osn5j2194">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold sm:pt-5 ${dark ? "text-goldlight" : "text-navy"}`} aria-hidden="true" data-id="element-28" data-mp="1zhvyuhqnb73z">
                :
              </span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-4 text-sm font-extrabold uppercase tracking-wide ${dark ? "text-goldlight" : "text-alert"}`} data-id="element-29" data-mp="x4rddlfh7dyt">
        Limited launch price
      </p>
      <p className={`mt-1 text-sm ${dark ? "text-white/70" : "text-ink/60"}`} data-id="element-30" data-mp="124cbxuqqhkb0">{caption}</p>
    </div>;
}